import React, {Component} from 'react';
//import dividerRight from '../../assets/images/divider-right.png';
import {Button, Divider} from 'semantic-ui-react';
import WorldMap from "./WorldMap";
import MobileWorldMap from "./MobileWorldMap";
import Banner from "../../widget/PageBanner";
import '../../assets/css/destinations.css';
import {Redirect} from 'react-router';

export default class Destinations extends Component{
	state = { 
		redirect: false,
		routeLink: ''
	};

	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}

	goToContactUs = () => {
		this.setState({
			redirect: true,
			routeLink: '/contactus'
		});
	}
	render(){
		const {redirect, routeLink} = this.state;
		return (
			
			<div className="world-map-wrapper">
				{ redirect &&
					<Redirect push to={routeLink}/>
				}
				<div className="travel-stories-wrapper mobile-world-map">
					<Banner pagename="Destinations"/>
				</div>
				<div className="world-map">
					<WorldMap/>
				</div>

				<div className="mobile-world-map section-content-wrapper">
					<MobileWorldMap/>
				</div>
				<div className="map-description">
					<br></br>
					<Divider className="mobile-world-map"></Divider>
					<div className="section-content-wrapper margin-top-5">
						<h1 className="section-header align-center">Personalize your tours</h1>
						<p className="para-content">
							Customize your own private adventure that’s tailored to exactly what you like and how you want to 
							experience the world. We have partners in more than 60 countries across the globe who help us 
							enhance your travel experiences. Find your next destination and we’ll make that dream trip happen.
						</p>
						<div className="align-center"><Button color='orange' onClick={this.goToContactUs}>Inquire now</Button></div>
					</div>
				</div>
				
			</div>
		);
	}
}
